<template>
    <v-card :class="`mag-teaser-sheet ${mode} color-${index % 4}`" @click="goto">
        <div class="title">
            <typo name="title-17-medium">
                {{ article.title }}
            </typo>
        </div>

        <v-card-subtitle>
            <typo name="body-17-medium">
                {{ publishedAt }}
            </typo>
        </v-card-subtitle>

        <v-card-text>
            <typo class="desc max-3-lines" name="body-14-normal">
                {{ body }}
            </typo>
        </v-card-text>
    </v-card>
</template>

<script>
import { Services } from "src/services/Services";

export default {
    props: ["article", "index", "mode"],
    computed: {
        body() {
            return this.article.body.replace(/<[^>]+>/g, "");
        },
        publishedAt() {
            if (this.article) {
                return Services.moment(this.article.publishedAt).format("LLL");
            }
            return null;
        },
    },
    methods: {
        goto() {
            this.$router.push({
                name: "article",
                params: {
                    category: this.article.articleCategoryName,
                    slugOrContentId: this.article.contentId,
                },
            });
        },
    },
};
</script>

<style lang="sass" scoped>

.mag-teaser-sheet
    margin: $grid-gutter $grid-gutter/2
    box-sizing: border-box
    &.flash
        width: calc(33.33% - 16px)
    &.half
        width: calc(50% - 16px)
    &.full
        width: 100%

.flash
    .title
        height: 185px
        padding: $grid-gutter
        box-sizing: border-box
        .typo
            display: -webkit-box
            text-align: left
            overflow: hidden
            text-overflow: ellipsis
            -webkit-line-clamp: 5
            -webkit-box-orient: vertical

.half
    .title
        padding: $grid-gutter
        height: 100px
        box-sizing: border-box
        .typo
            display: -webkit-box
            text-align: left
            overflow: hidden
            text-overflow: ellipsis
            -webkit-line-clamp: 2
            -webkit-box-orient: vertical
.full
    .title
        padding: $grid-gutter

.desc
    color: $color-secondary

.color-0
    .title
        background: $color-yellow

.color-1
    .title
        background: $color-pink

.color-2
    .title
        background: $color-blue

.color-3
    .title
        background: $color-grey

.max-3-lines
    display: inline-block
    overflow: hidden
    max-height: 4em
</style>
